import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevrons-down-left', 'ChevronsDownLeft', [["path",{"d":"M11 5v8h8"}],["path",{"d":"M7 9v8h8"}]]);